import { queue } from "@budibase/backend-core"
import { AppBackupQueueData } from "@budibase/types"

let backupQueue: queue.BudibaseQueue<AppBackupQueueData>

export function init() {
  backupQueue = new queue.BudibaseQueue<AppBackupQueueData>(
    queue.JobQueue.APP_BACKUP,
    {
      maxStalledCount: 3,
      jobOptions: {
        attempts: 3,
        removeOnFail: true,
        removeOnComplete: true,
      },
    }
  )
}

export function getBackupQueue() {
  return backupQueue
}
